export default __webpack_public_path__ + "static/media/desktop.241267ee.jpg";